import { createTheme } from "@mui/material";

export function createMuiTheme(mode, passedTheme){
    const constructedTheme= createTheme({
        ...createTheme().typography,
        ...createTheme().spacing,
        ...createTheme().shadows,
        ...createTheme().breakpoints,
        ...createTheme().components,
        typography:{
          fontSize: 12,
        },
        palette:{
          mode: mode,
          primary: {
            main: passedTheme.primary,
            contrastText: passedTheme.primaryText
          },
          secondary: {
            main: passedTheme.secondary,
            contrastText: passedTheme.secondaryText
          },
          white: {
            main: passedTheme.white,
            contrastText: passedTheme.whiteText
          },
          light: {
            main: passedTheme.light,
            contrastText: passedTheme.lightText
          },
          background: {
            default: passedTheme.background
          },
          text: {
            primary: passedTheme.text
          },
          
        },
    });
    return constructedTheme;
}